import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mtd-report',
  templateUrl: './mtd-report.component.html',
  styleUrls: ['./mtd-report.component.css']
})
export class MtdReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
